import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

function NoPermissionModal({ show, onHide, requiredRole, currentRole }) {
    const navigate = useNavigate();

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>권한 안내</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center mb-3">
                    <FontAwesomeIcon icon={faLock} size="3x" className="text-warning" />
                </div>
                <p>
                    이 기능을 사용하기 위해서는 <strong>{requiredRole}</strong> 이상의
                    권한이 필요합니다.
                </p>
                <p>
                    현재 귀하의 권한은 <strong>{currentRole}</strong> 입니다.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    닫기
                </Button>
                <Button
                    variant="primary"
                    onClick={() => {
                        onHide();
                        navigate('/support/inquiry');
                    }}
                >
                    권한 요청하기
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default NoPermissionModal;